export const validateEmail = (email: string) =>
  /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email);

export const validateNumber = (number: string) => /^([0-9]*)$/.test(number);

export const validateDecimalNumber = (decimalNumber: string) =>
  /^([0-9]+\.?[0-9]*|[0-9]+)$/.test(decimalNumber);
